import { render, staticRenderFns } from "./DividerItem.vue?vue&type=template&id=11d20cf4&scoped=true&"
import script from "./DividerItem.vue?vue&type=script&lang=js&"
export * from "./DividerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d20cf4",
  null
  
)

export default component.exports